import React, {useCallback, useState} from 'react';
import {Button, Badge} from 'web-components';
import {AppliedFiltersContainer, AppliedFiltersTop, SmallTitle, Buttons, AppliedFiltersFlexFlow, BadgeWrapper} from './filter.styled';
import {findElementFromId, getTypeLabel, getGroupLabel} from './filter_util';
import tracking from '../../../../tracking';
import CustomScrollDiv from '../scroll-bars/custom_scroll_div';
export const AppliedFiltersSection = ({viewer, intl, advancedFilter, appliedFilters, onRemoveFilter, onClearFilters, clickOnSave}) => {
	const handleSaveFilter = () => {
		tracking.trackPageAction('Filter saved');
		clickOnSave();
	};

	const [_height, setHeight] = useState(null);
	const div = useCallback(div => {
		if (div) {
			//22 is the height of the AppliedFiltersTop
			setHeight(div.getBoundingClientRect().height - 22);
		}
	}, []);

	const getFilter = () => {
		let filters = [];
		appliedFilters.forEach(filter => {
			const element = findElementFromId(filter.filterType, filter.id, viewer, intl.formatMessage, intl);
			if (element.value === null) {
				tracking.trackEvent('filter not found');
			}
			filters.push(
				<BadgeWrapper key={filter.id}>
					<Badge
						title={(advancedFilter ? getGroupLabel(filter.section, intl.formatMessage) + ' / ' : '') + getTypeLabel(filter.filterType, intl.formatMessage)}
						text={element.value || intl.formatMessage({id: 'common.not_found'})}
						onRemoveClick={() => onRemoveFilter(filter.section, filter.filterType, [filter.id])}
						disabled={element.value === null}
					/>
				</BadgeWrapper>
			);
		});

		return filters;
	};

	return (
		<AppliedFiltersContainer ref={div}>
			<AppliedFiltersTop>
				<SmallTitle>{intl.formatMessage({id: 'filter_content.applied_filters'})}</SmallTitle>
				<Buttons>
					<Button size={Button.SIZE.SMALL} variant={Button.VARIANT.VERY_LIGHT_GRAY_OUTLINE} onClick={onClearFilters}>
						{intl.formatMessage({id: 'common.clear'})}
					</Button>
					<Button size={Button.SIZE.SMALL} variant={Button.VARIANT.GREEN_FILLED} disabled={appliedFilters.length === 0} onClick={handleSaveFilter} userpilot={'filter-save-button'}>
						{intl.formatMessage({id: 'filter_content.save_filters'})}
					</Button>
				</Buttons>
			</AppliedFiltersTop>
			<CustomScrollDiv autoHeight={true} autoHeightMin={1} autoHeightMax={_height}>
				<AppliedFiltersFlexFlow>{getFilter()}</AppliedFiltersFlexFlow>
			</CustomScrollDiv>
		</AppliedFiltersContainer>
	);
};
